<template>
    <div class="home page noTopPadding" @scroll="pageScroll" ref="page" >
        
        
        <!--SLIDER-->
        <transition name="fade">
            <div
                class="slickSlider"
                v-if="startAnimation"
                
            >
                <!--v-touch:swipe.stop-->
                <div
                    class="slide"
                    v-for="slide in preloaded.slider"
                >
                    <div class="container">
                        <div>
                            <div class="text" v-if="getLng() == 'en'">{{slide.text}}</div>
                            <div class="text" v-else>{{slide.spanish_text}}</div>
                            <router-link :to="{ path: slide.link }" class="mkButton mkBig">{{ $t("home.Learn More") }}</router-link>
                            <!--<router-link :to="{ path: '/recipes?filter=4' }" class="mkButton mkBig">Learn More</router-link>-->
                        </div>
                        <img :src="slide.image">
                    </div>
                </div>
            </div>
        </transition>
        <div class="pageContainer">
            <div class="container">
    
                <!--Products-->
                <div class="products mb-3">
                    <h2 class="mt-4 mb-3">{{ $t('home.Explore Cocktail Mixes & Ingredients')}}</h2>
                    
                    <transition-group
                        class="list"
                        name="fadeUp"
                        tag="div"
                    >
                        <div :key="1" v-if="startAnimation" class="listItem" @click="$router.push({name:'products',query:{brand:'real'}})">
                            <div class="listIContainer">
                                <div class="imgBox">
                                    <img :src="getStaticImage('real-product.png')">
                                </div>
                                {{ $t('home.Reàl Products')}}
                            </div>
                        </div>
                        <div  :key="2" v-if="startAnimation" class="listItem" style="animation-delay: 0.1s"  @click="$router.push({name:'products',query:{brand:'finest'}})">
                            <div class="listIContainer">
                                <div class="imgBox">
                                    <img :src="getStaticImage('finest-call-product.png')">
                                </div>
                                {{ $t('home.Finest Call Products')}}
                            </div>
                        </div>
                    </transition-group>
                </div>
                
                <!--Favorites-->
                <div class="favorites">
                    <h2 class="d-flex justify-content-between align-items-center pt-4 pb-2">
                        <span>{{ $t('home.Trending Recipes')}}</span>
                        <router-link class="mkButton" :to="{name:'recipes', query: {page_filter: 0}}">{{ $t('home.All Recipes')}}</router-link>
                    </h2>
                    <transition-group
                        name="fadeUp"
                        tag="div"
                        class="list"
                    >
                        <RecipeListItem
                            v-for="(favorite, index) in preloaded.favorites"
                            :style="{ animationDelay:  (index* 0.25) + 's' }"
                            v-if="startAnimation"
                            :key="favorite.id"
                            :recipe="favorite"
                            class="listOf3"
                        ></RecipeListItem>
                    </transition-group>
                </div>
                
                <!--Featured Mixologists -->
                <div class="featuredMixologists">
                    <h2 class="d-flex justify-content-between align-items-center pt-4 pb-2">
                        <span>{{ $t('home.Mixologists')}}</span>
                         <router-link class="mkButton" :to="{name:'mixologists'}">{{ $t('home.View All')}}</router-link>
                         
                    </h2>
                    <transition name="fade">
                        <div
                            class="list"
                            v-if="startAnimation"
                            
                        >
                            <div
                                class="listItem"
                                v-for="m in preloaded.featuredMixologists"
                            >
                                <router-link :to="{name:'mixologists', query: { mixologist: m.id }}">
                                    <div class="listIContainer">
                                        <div class="imgBox">
                                            <img class="img-fluid" :src="m.featured_image ? m.featured_image : getStaticImage('logo.png')"></img>
                                        </div>
                                    {{m.name}}
                                    </div>
                                </router-link>
                            </div>
                        </div>
                    </transition>
                    
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>

    import RecipeListItem from "../components/RecipeListItem";
    // import MixologistListItem from "../components/MixologistListItem";

    import pageMixin from "../mixins/page";

    import {mapState} from "vuex"

    import $ from "jquery";
    import "slick-carousel";

    export default {
        name: 'home',
        mixins: [pageMixin],
        components: {RecipeListItem},
        data() {
            return {
            };
        },
        methods: {
            initSlick() {
                $(".slickSlider").slick({
                    arrows: false,
                    dots: true,
                    slidesToShow: 1,
                    autoplay: true,
                    autoplaySpeed: 5000,
                });
            },
            getLng() {
                return localStorage.getItem( 'lng' ) || 'en';
            }

        },
        computed: {
            ...mapState("shared", ["preloaded"])
        },
        mounted(){
            this.changePageTitle("Amazing Drink Recipes | Cocktail Recipe App | ABM Cocktail Pro");
        },
        beforeUpdate() {
            $(".slickSlider").slick('unslick');
        },
        updated() {
            this.initSlick();
        }
    }
</script>


